module.exports = "/* MAIN COLOR PALETTE */\n.login-btn {\n  color: white;\n  background-color: #B71C1C; }\n.enlace {\n  /* Registrarme: */\n  font-family: Roboto-Italic;\n  font-size: 14px;\n  color: #D0021B;\n  /* Line: */\n  border: 0 solid #D0021B; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modals/restore-password/restore-password.component.scss
// module id = ./src/app/components/modals/restore-password/restore-password.component.scss
// module chunks = main